export default __webpack_public_path__ + "static/media/chapter1.f83e7cce.jpg";